import React, { Component } from 'react';
import classNames from 'classnames';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { logout } from '../../../actions/userActions';

import './Logout.css';

class Logout extends Component {
  handleLogout = () => {
    this.props.logout();
    browserHistory.replace('/');
  }

  render() {
    const classes = classNames('Logout', this.props.className);

    return (
      <div className={classes} onClick={this.handleLogout} role="button">
        Logout
      </div>
    );
  }
}

export default connect(null, { logout })(Logout);



// WEBPACK FOOTER //
// ./src/components/auth/Logout/Logout.js